<template lang="html">
  <section class="field-row">
    <div class="expression" ref="expContainer">
      <expressions
        :data-elements="allSources"
        :selected-source="selectedSource"
        :initial-expression="field.expression"
        :data-type="dataType"
        :content-type="appType"
        @on-expression-field-valid="onConfigExpressionValid"
      />
    </div>
    <div class="sort-by-container">
      <b-form-select
        v-model="field.sortDir"
        :options="sortDirection"
        @change="onSortDirectionSelected()"
        size="sm"
      />
    </div>
    <div class="delete-wrapper">
      <svg
        class="delete-row-icon"
        tabindex="0"
        @keydown.enter.stop="onFieldRowDelete()"
        @click="onFieldRowDelete()"
      >
        <use
          xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#delete"
        ></use>
      </svg>
    </div>
  </section>
</template>

<script lang="js">
  import { mapState } from "vuex";
  import Expressions from "@/components/Expressions"
  export default  {
    name: "field-row",
    components: {
      Expressions
    },
    props: {
      id: {
        type: String
      },
      field: {
        type: Object
      },
      allSources: {
        type: Object
      },
      selectedSource: {
        type: Object
      },
      contextDe: {
        type: Object
      },
      comparables: {
        type: Object
      },
      level: {
        type: Number
      },
      shouldFocus: {
        type: Boolean
      },
      dataType: {
        type: String
      },
      appType: {
        type: String
      }
    },
    computed: {
      ...mapState({
        messages: "messages"
      }),
      sortDirection() {
        return [{
            text: this.getMessageText(this.messages.ASCENDING),
            value: "ASC"
          }, {
            text: this.getMessageText(this.messages.DESCENDING),
            value: "DESC"
          }
        ];
      }
    },
    mounted () {
      this.field.valid = Boolean(this.field.expression);
      if(this.shouldFocus) {
        setTimeout(() => {
          this.$refs.expContainer.getElementsByClassName("m-input")[0].focus();
        }, 20)
      }
    },
    methods: {
      onConfigExpressionValid(ctx) {
        this.field.expression = ctx.confExpression;
        this.field.valid = ctx.status;
        this.onFieldRowChange();
      },
      onSortDirectionSelected() {
        this.onFieldRowChange();
      },
      onFieldRowChange() {
        this.$emit("on-field-row-change", this.field);
      },
      onFieldRowDelete() {
        this.$emit("on-field-row-delete", this.field);
      }
    }
  }
</script>

<style scoped lang="scss">
  .field-row {
    display: flex;
    align-items: center;
    .expression {
      flex: 5;
      margin-right: 1rem;
    }
    .sort-by-container {
      flex: 1;
      min-width: 10rem;
    }
    .delete-wrapper {
      margin-left: 0.5rem;
      .delete-row-icon {
        height: 1.25rem;
        width: 1.25rem;
        fill: #c23934;
        cursor: pointer;
      }
    }
  }
</style>
